/**
 * React hook providing a GatewayClient instance tied to the current auth session.
 *
 * Returns `null` when the user is not authenticated.
 */

import { useMemo } from 'react';
import { useAuth } from '../auth/auth-context';
import { createGatewayClient, type GatewayClient } from './gateway-client';

export function useGateway(): GatewayClient | null {
  const { sessionToken, gatewayUrl, isAuthenticated, logout } = useAuth();

  return useMemo(() => {
    if (!isAuthenticated || !sessionToken) return null;
    return createGatewayClient(gatewayUrl, sessionToken, logout);
  }, [sessionToken, gatewayUrl, isAuthenticated, logout]);
}
